---
title: 'Step 3: Configure the Collector'
install_track_title: 'Log Insights: Setup (Aiven)'
backlink_href: /docs/log-insights/setup
backlink_title: 'Log Insights: Setup'
---

import imgGcpFirewallRules from './gcp-firewall-rules.png'
import imgAwsSecurityGroup from './aws-security-group.png'

export const ImgGcpFirewallRules = () => <img alt="GCP firewall rules allowing access on syslog port" src={imgGcpFirewallRules} />

export const ImgAwsSecurityGroup = () => <img alt="AWS Security Group allowing access on syslog port" src={imgAwsSecurityGroup} />

We can now configure the syslog receiver in the collector. Edit the collector
config and add the
[`db_log_syslog_server`](https://pganalyze.com/docs/collector/settings#self-managed-servers)
setting. This should be set to a local address on any free port:

<CodeBlock language="text">
{`db_log_syslog_server: 0.0.0.0:32514`}
</CodeBlock>

(If using Docker, use the `LOG_SYSLOG_SERVER` environment variable instead.)

It's recommended to use an unprivileged port number (1024 and up) to avoid
running the collector as root.

Restart the collector.

Make sure that the port you've selected is not blocked for TCP traffic by a
firewall or security group rules. E.g., in GCP, you'll need to add a firewall
rule:

<ImgGcpFirewallRules />

In AWS, you'll need to add a security group rule:

<ImgAwsSecurityGroup />

After the port is exposed to the peered network, configure Aiven to send
logs to the collector:

<Link className="btn btn-success" to="04_configure_service_integration">
  Continue to Step 4: Configure Service Integration
</Link>
